module.exports = __webpack_public_path__ + "static/media/featuresection1.55e3524a.png";